import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";

export const Section = ({ title, subtitle, children }) => (
  <div className="trent-card p-6 md:p-8">
    <div className="text-[10px] uppercase tracking-[0.3em] text-[#16A34A] mb-1">{title}</div>
    <h2 className="trent-heading text-2xl font-black tracking-tighter text-[#1E3A5F] mb-2">{subtitle}</h2>
    <div className="border-t border-[#E5E7EB] my-6" />
    {children}
  </div>
);

export const NextBar = ({ onPrev, onNext, testId }) => (
  <div className="flex justify-between mt-8 pt-6 border-t border-[#E5E7EB]">
    {onPrev ? (
      <button onClick={onPrev} className="trent-btn-secondary">
        <ArrowLeft weight="bold" size={14} /> Back
      </button>
    ) : <div />}
    <button onClick={onNext} className="trent-btn-primary" data-testid={testId}>
      Continue <ArrowRight weight="bold" size={14} />
    </button>
  </div>
);

export const In = ({ label, v, on, full, wide, type = "text", textarea, test }) => (
  <label className={`block ${full ? "md:col-span-2" : ""} ${wide ? "md:col-span-2" : ""}`}>
    <span className="text-xs font-semibold uppercase tracking-wider text-[#6B7280]">{label}</span>
    {textarea ? (
      <textarea value={v} onChange={(e) => on(e.target.value)} rows={3} className="trent-input mt-1" data-testid={test} />
    ) : (
      <input type={type} value={v} onChange={(e) => on(e.target.value)} className="trent-input mt-1" data-testid={test} />
    )}
  </label>
);

export const Sel = ({ label, v, on, opts, test }) => (
  <label className="block">
    <span className="text-xs font-semibold uppercase tracking-wider text-[#6B7280]">{label}</span>
    <select value={v} onChange={(e) => on(e.target.value)} className="trent-input mt-1" data-testid={test}>
      {opts.map((o) => <option key={o} value={o}>{o || "—"}</option>)}
    </select>
  </label>
);
